/**
 * The portal page open in the landing page editor, if any. The editor is the
 * collection (showcase) landing page editor; while a portal page is set, its
 * landing page requests go to that page instead (see api/collection) and
 * closing the editor returns to `returnTo`.
 *
 * Set by the collection route before the editor renders; cleared on unmount.
 *
 * @type {{ pageId: string, name: string, path: string, slug?: string,
 *   type: string, returnTo: string } | null}
 */
let current = null
const listeners = new Set()

export const setPortalPageEditing = value => {
  current = value
  listeners.forEach(listener => listener(current))
}

export const getPortalPageEditing = () => current

/** Calls `listener` whenever the open page changes (e.g. it is renamed); returns the unsubscribe. */
export const subscribePortalPageEditing = listener => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/** Writes a page name into the editor header's title, whichever template it uses. */
export const showHeaderTitle = title => {
  document
    .querySelectorAll(
      '.hero-title, .promo-title, .course-container-header-text',
    )
    .forEach(element => {
      element.textContent = title
    })
}
